// extracted by mini-css-extract-plugin
export default {"section":"Hero_section__X7+jH","card":"Hero_card__QgD27","card-buttons":"Hero_card-buttons__52BKY","button":"Hero_button__Tgm4e","info":"Hero_info__+zXHf"};